<template>
  <div></div>
</template>

<script setup lang="ts">
import { Notification } from 'element-ui';
// /coupon/userExpiringSoonCoupon
import { getUserExpiringSoonCoupon } from '@/api/coupon';
import { userInfo } from '@/stores/userInfo';
const userStore = userInfo();
const props = defineProps({
  offSet: {
    type: Number,
    default: 0,
  },
});

watchEffect(() => {
  if (userStore.isLogin) {
    getUserExpiringSoonCoupon().then(res => {
      Notification.closeAll();
      const commonObj = {
        customClass: 'coupon-notify',
        duration: 60000,
        position: 'top-right',
        iconClass: 'el-icon-bell',
        offset: props.offSet,
        onClick: () => {
          useRouter().push('/usercenter/coupon');
        },
      };
      if (res.data?.expiringSoonCoupon && res.data.expiringSoonCoupon?.id) {
        Notification({
          message: '您有一张' + res.data.expiringSoonCoupon.couponAmount + '元满减券即将到期，请尽快使用！',
          ...commonObj,
        });
      }

      if (res.data?.newCoupon && res.data.newCoupon?.id) {
        Notification({
          message: '您收到一张' + res.data.newCoupon?.couponAmount + '元满减券！',
          ...commonObj,
        });
      }
    });
  }
});

//
</script>

<style lang="scss">
.coupon-notify {
  background: var(--el-color-danger) !important;
  padding: 10px !important;
  border-color: var(--el-color-danger) !important;
  right: 80px !important;
  width: 360px !important;
  display: flex !important;
  align-items: center;
  overflow: visible !important;
  &::after {
    content: '';
    position: absolute;
    right: -5px;
    top: 16px;
    width: 10px;
    height: 10px;
    transform: rotate(45deg);
    opacity: 1;
    /* 危险/100% */
    background: #f56c6c;
  }

  .el-notification__content {
    cursor: pointer;
    margin-top: 0px !important;
    margin-right: 12px !important;
    p {
      color: #fff !important ;
    }
  }
  .el-notification__icon {
    color: #fff !important;
    font-size: 14px;
    width: 14px;
    height: 14px;
  }
  .el-notification__closeBtn {
    color: #fff !important;
    top: 14px !important;
  }
}
</style>
